module.exports = __webpack_public_path__ + "img/AI (6).b34882c5.png";